<div class="row justify-content-center mb-3">
  <div class="col-12 col-md-9 col-lg-6">
    <div class="preview-summary row">
      <div class="col-sm-auto">
        <h2 class="preview-title">{{ user?.user?.firstName }} {{ user?.user?.lastName }}</h2>
        <div class="d-flex align-items-center pr-3">
          <i class="ftmi-user mr-1"></i>
          {{ user?.role?.code }}
        </div>
        <div class="d-flex align-items-center pr-3">
          <i class="ftmi-email mr-1"></i>
          {{ user?.user?.email }}
        </div>
        <div *ngIf="user?.graduationYear" class="d-flex align-items-center pr-3">
          <i class="ftmi-user-graduation mr-1"></i>
          {{ user?.graduationYear }}
        </div>
      </div>

      <div class="col-sm-auto ml-sm-auto">
        <button class="btn btn-outline-primary btn-sm" (click)="onEditUser()" [appTooltip]="'EDIT' | translate">
          {{ 'EDIT' | translate }} <i class="icon icon-right ftmi-edit"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="row justify-content-center mb-3">
  <div class="col-12 col-md-9 col-lg-6" *ngIf="studentMetrics?.attendanceLast5FlexDays">
    <div class="white-panel p-3">
      <div class="caption border-bottom pb-2 mb-3">{{ 'ATTENDANCE_LAST_5_FLEX_DAYS' | translate }}</div>
      <div class="d-flex justify-content-between">
        <div class="counter-col">
          <div class="count-badge present">{{ studentMetrics?.attendanceLast5FlexDays?.countPresent }}</div>
          <div class="count-badge-label">{{ 'PRESENT' | translate }}</div>
        </div>
        <div class="counter-col">
          <div class="count-badge absent">{{ studentMetrics?.attendanceLast5FlexDays?.countAbsent }}</div>
          <div class="count-badge-label">{{ 'ABSENT' | translate }}</div>
        </div>
        <div class="counter-col">
          <div class="count-badge late-u">{{ studentMetrics?.attendanceLast5FlexDays?.countLateUnexcused }}</div>
          <div class="count-badge-label">{{ 'LATE_UNEXCUSED' | translate }}</div>
        </div>
        <div class="counter-col">
          <div class="count-badge late-e">{{ studentMetrics?.attendanceLast5FlexDays?.countLateExcused }}</div>
          <div class="count-badge-label">{{ 'LATE_EXCUSED' | translate }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row justify-content-center mb-3" *ngIf="studentMetrics">
  <div class="col-12 col-md-9 col-lg-6">
    <div class="meta-panel">
      <div class="my-3">
        <div class="row">
          <div class="col-12">
            <div class="caption mb-3">{{ 'CURRENT_SCHOOL_YEAR_DATA' | translate }}</div>
            <div class="caption">{{ 'TOTAL_ACTIVITIES' | translate }}</div>
            <div class="activities-total">{{ studentMetrics.activities.total }}</div>
          </div>
          <div class="col-12">
            <div class="mt-3 mb-2 d-flex">
              <div *ngIf="studentMetrics.activities.total > 0" class="chart-container">
                <canvas
                  baseChart
                  [chartType]="appConfig.ChartType"
                  [options]="appConfig.ChartOptions"
                  [data]="chartData.activitiesCurrentSchoolYear.data"
                  [labels]="chartData.activitiesCurrentSchoolYear.labels"
                  [colors]="chartData.activitiesCurrentSchoolYear.colors"
                >
                </canvas>
              </div>
              <div class="ml-3">
                <ul class="chart-legend">
                  <li
                    *ngFor="let item of chartData.activitiesCurrentSchoolYear.labels; index as i"
                    [className]="applyLabelClass(i, chartData.activitiesCurrentSchoolYear.colors)"
                  >
                    <span>{{ item }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div *ngIf="studentMetrics.activities.total === 0" class="col-12">
            <div class="alert justify-content-center">
              {{ 'NO_ACTIVITIES_AND_ATTENDANCE' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row justify-content-center mb-5" *ngIf="studentRestriction">
  <div class="col-12 col-md-9 col-lg-6">
    <div class="meta-panel h-100">
      <div class="meta-panel-header">
        <div class="title">
          {{ 'RESTRICTIONS' | translate }}
          <span class="text-primary"> {{ studentRestriction.countActiveRestrictions }}</span
          >/{{ studentRestriction.countTotalRestrictions }}
        </div>
        <button routerLink="/{{ appRoute.RestrictedStudents }}" class="btn btn-link ml-auto">
          {{ 'SEE_ALL' | translate }}
        </button>
      </div>
      <div class="my-3">
        <div class="row" *ngIf="studentRestriction.countActiveRestrictions">
          <div class="col-12">
            <div class="activity-meta">
              <div class="meta-label"><i class="icon ftmi-teacher"></i> {{ 'TEACHER' | translate }}</div>
              {{ studentRestriction.latestRestriction.teacher }}
            </div>

            <div class="activity-meta">
              <i class="icon ftmi-calendar"></i>
              {{ studentRestriction.latestRestriction.created | extendedDate : appConfig.Formats.DateFormat }} -
              {{ studentRestriction.latestRestriction.endDate | extendedDate : appConfig.Formats.DateFormat }}
            </div>
          </div>
          <div class="col ml-auto">
            <i class="icon ftmi-file"></i>
            <span>{{ studentRestriction.latestRestriction.notesToStudent.length }}</span>
          </div>
        </div>
        <div *ngIf="studentRestriction.countActiveRestrictions === 0" class="col-12">
          <div class="alert justify-content-center">
            {{ 'NO_ACTIVE_RESTRICTION' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
